module.exports = __webpack_public_path__ + "img/LongWanRM.14d6421a.png";